module.exports = __webpack_public_path__ + "static/media/support.d7e6bcb5.svg";